import React, { Component } from "react";
import { Button, Icon } from "semantic-ui-react";
import Table,  { Column } from 'react-base-table';
import 'react-base-table/styles.css';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import moment from 'moment';
import './styles.scss';
import { getTotalRecordByDate, getTotalRecordByDate2, getDataDepartmentAndEmployee, getDataDepartmentAndEmployeeExport, deleteDataEmployeeExport } from "../../core/actions/totalRecordByDateAction";
import { getTotalRecordByProject } from "../../core/actions/totalRecordByProjectAction";
import { getProjectEmployeeSort } from "../../core/actions/projectEmployeeSortAction";
import TotalRecordForm from '../../components/TotalRecordForm';
import ERModal from '../../components/ERModal';
import { exportAllEmployee, exportErStatus, exportFileAction } from "../../core/actions/commonAction";
import functionCommon from "../../core/common/function";
import _ from 'lodash';

let isStaffSupervisor = false;
class TotalRecord extends Component {
    constructor(props) {
        super(props);
        const regex = /[?&]([^=#]+)=([^&#]*)/g;
        const url = window.location;
        let  params = {};
        let match;
        while(match = regex.exec(url)) {
            params[match[1]] = match[2];
        }
        const _currentMonth = (params['month'] && params['month'].length === 2) ? params['month'] : moment().format('MM');
        const _currentYear = (params['year'] && params['year'].length === 4) ? params['year'] : moment().format('YYYY');
        const _searchBy = (params['searchBy'] && (params['searchBy'] === 'date' || params['searchBy'] === 'project')) ? params['searchBy'] : 'date';
        const _projectId = params['projectId'] ? params['projectId'] : '';
        this.state = {
            currentYear: _currentYear,
            currentMonth:   _currentMonth,
            paramListByDate: {
                isSearch: 0,
                month: _currentMonth,
                year: _currentYear,
                departmentBy: "createdDate-ASC",
                projectBy: "projectCode-ASC",
                employeeBy: "lastName-ASC",
                departmentId: '',
                employeeId: [''],
            },
            paramListByProject: {
                isSearch: 1,
                projectId: _projectId,
                month: _currentMonth,
                year: _currentYear,
                departmentBy: "createdDate-ASC",
                projectBy: "projectCode-ASC",
                employeesBy: "lastName-ASC",
                employeeProjectBy: "createdDate-ASC",
                departmentId: '',
                employeeId: [''],
            },
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
            projectId: _projectId,
            errorCode: "",
            totalDateByDepartment: [],
            projectSortCombobox: [],
            projectSortTable: [],
            columnsByDate: [],
            columnsByProject: [],
            dataByDate: [],
            dataByProject: [],
            dateInMonth: [],
            totalRecordBy: _searchBy,
            searchBy: _searchBy,
            open: false,
            OMProjectList: [],
            employeeList: [],
            supervisorList: [],
            approverList: [],
            searching: true,
            projectsLength: 1,
            listEmloyeeSlectBox: [],
            departmentListSelectBox: [],
            listEmloyeeSlectBoxExport: [],
            departmentListSelectBoxExport: [],
            employeeId: [''],
            departmentId: '',
            employeeIdExport: [],
            paramDepartmentListAndEmployee: {
                departmentId: '',
                departmentBy: "createdDate-ASC",
                employeeBy: "firstName-ASC",
            },
            paramDepartmentListAndEmployeeExport: {
                departmentId: '',
                departmentBy: "createdDate-ASC",
                employeeBy: "firstName-ASC",
            },
        }
    }

    componentWillMount() {
        if (functionCommon.getRole() === 'staff' && functionCommon.getLevel() === 'supervisor') {
            isStaffSupervisor = true;
        }

        // Call API totalrecordbydate-list
        this.props.getDataDepartmentAndEmployee(this.state.paramDepartmentListAndEmployee);
        if (!isStaffSupervisor) {
            if (this.state.searchBy === 'date') {
                this.props.getTotalRecordByDate2(this.state.paramListByDate);
            } else {
                this.props.getTotalRecordByProject(this.state.paramListByProject);
            }
        }
        this.props.getProjectEmployeeSort({
            employeeId: '',
            projectSort: 'projectCode-ASC',
            employeeSort: 'employeeCode-ASC',
            approverSort: 'lastName-ASC'
        });
    }

    componentWillReceiveProps(nextProps) {
        let dataByDate = nextProps.totalRecordByDateReducer2.dataTotalRecordByDate2;
        let dataByProject = nextProps.totalRecordByProjectReducer.dataTotalRecordByProject;
        let _projectSortCombobox = dataByDate.projectSortCombobox !== undefined ? dataByDate.projectSortCombobox : dataByProject.projectSortCombobox;
        let _projectSortTable = nextProps.totalRecordByProjectReducer.dataTotalRecordByProject.projectSortTable || [];
        let date = functionCommon.dateInMonth(this.state.currentMonth, this.state.currentYear);
        let _OMProjectList = nextProps.projectEmployeeSortReducer.dataProjectEmployeeSort.omProject;
        let _employeeList = nextProps.projectEmployeeSortReducer.dataProjectEmployeeSort.employeeSortCombobox;
        let _supervisorList = nextProps.projectEmployeeSortReducer.dataProjectEmployeeSort.suppervisor;
        let _approverList = nextProps.projectEmployeeSortReducer.dataProjectEmployeeSort.approver;
        let _listEmloyeeSlectBox = nextProps.departmentAndEmployeeReducer.listEmployeeSelectBox;
        let _departmentListSlectBox = nextProps.departmentAndEmployeeReducer.listDepartmentSelectBox;
        let _listEmloyeeSlectBoxExport = nextProps.departmentAndEmployeeReducerExport.listEmployeeSelectBoxEx;
        let _departmentListSlectBoxExport = nextProps.departmentAndEmployeeReducerExport.listDepartmentSelectBox;

        if (nextProps.totalRecordByDateReducer2.isLoading) {
            if (this.state.searchBy === "date" ) {
                // No data by date
                if (dataByDate['departmentEmployee'] === undefined) {
                    this.setState({
                        errorCode: "018",
                        searching: false
                    });
                    setTimeout(
                        function () {
                            this.setState({ errorCode: "" });
                        }.bind(this),
                        2000
                    );

                } else {
                    this.setState({
                        errorCode: '',
                        searching: false
                    });
                }
            }
        }

        if (nextProps.totalRecordByProjectReducer.isLoading) {
            if (this.state.searchBy === "project" ) {
                // No data by date
                if (dataByProject && dataByProject['departmentEmployee'] !== undefined
                    && !dataByProject['departmentEmployee'][0]) {
                    this.setState({
                        errorCode: "018",
                        searching: false
                    });
                    setTimeout(
                        function () {
                            this.setState({ errorCode: "" });
                        }.bind(this),
                        2000
                    );

                } else {
                    this.setState({
                        errorCode: '',
                        searching: false
                    });
                }
            }
        }

        const { t } = this.props;
        
        let _columnsByDate = [
            {
                title: t('labels.item'),
                width: 280,
                dataKey: 'name',
                key: 'name',
                frozen: true
            },
            {
                title: t('labels.totalHour'),
                width: 100,
                dataKey: 'totalHour',
                key: 'totalHour'
            },
            {
                title: t('labels.totalOT'),
                width: 100,
                dataKey: 'totalOT',
                key: 'totalOT'
            }
        ].concat(date.map((date, index) => {
            return {
                key: index,
                title: parseInt(date.day),
                dataKey: 'day_' + parseInt(date.day),
                width: 60
            }
        }));

        this.setState({
            columnsByDate: _columnsByDate
        });

        let _columnsByProject = [
            {
              title: t('labels.item'),
              width: 280,
              dataKey: 'name',
              key: 'name',
              frozen: true,
            },
            {
              title: t('labels.totalHour'),
              width: 100,
              dataKey: 'totalHour',
              key: 'totalHour',
            }
        ].concat((this.state.paramListByProject.projectId === '') ? _.map(_projectSortTable, (item, index) => {
            this.setState({
                projectsLength: _projectSortTable.length
            });

            return {
                key: index,
                title: item.projectName,
                dataKey: 'projectId_' + item.id,
                width: 200,
                headerClassName: 'header-project'
            }
        }) : _.map(_projectSortTable.filter(x => x.id == this.state.paramListByProject.projectId), (item, index) => {
            this.setState({
                projectsLength: 1
            });

            return {
                key: index,
                title: item.projectName,
                dataKey: 'projectId_' + item.id,
                width: 200,
                headerClassName: 'header-project'
            }
        }));

        this.setState({
            columnsByProject: _columnsByProject
        });

        let _dataByDate = [];
        if (dataByDate && dataByDate['departmentEmployee']) {
            _dataByDate = _.map(dataByDate['departmentEmployee'], (dep, index) => {
                return ({
                    "id": `${index}`,
                    "name": dep.departmentName,
                    "totalHour": this.fixDecimal(dep.totalHourDepartment),
                    "totalOT": (dep.totalOTDepartment !== 0) ? this.fixDecimal(dep.totalOTDepartment) : '',
                    "children": _.map(dep.workLog, (emp, idx) => {
                        return ({
                            "id": `${index}-${idx}`,
                            "name": emp.employeeName,
                            "totalHour": this.fixDecimal(emp.totalHourEmployee),
                            "totalOT": "",
                            "employeeId": emp.employeeId,
                            "children": [{
                                "id": `${index}-${idx}-0`,
                                "name": "OT",
                                "totalHour": "",
                                "totalOT": (emp.totalOTEmployee !== 0) ? this.fixDecimal(emp.totalOTEmployee) : '',
                            }]
                        })
                    })
                })
            });
        }

        _.map(date, (date, i) => {
            if (dataByDate && dataByDate['departmentEmployee']) {
                _.map(dataByDate['departmentEmployee'], (dep, index) => {
                    if (_dataByDate[index] !== undefined) {
                        if (dataByDate['totalDateByDepartment'][dep.departmentId] !== undefined) {
                            _.map(dataByDate['totalDateByDepartment'][dep.departmentId], ite => {
                                if (parseInt(ite.date.slice(-2)) === parseInt(date.day)) { 
                                    _dataByDate[index]['day_'+parseInt(date.day)] 
                                    = this.fixDecimal(ite.totalDateDepartment)
                                }
                            });
                        }

                        _.map(dep.workLog, (emp, idx) => {
                            if (_dataByDate[index]['children'][idx] !== undefined) {
                                _.map(emp.workLogDate, item => {
                                    if (parseInt(item.date.slice(-2)) === parseInt(date.day)) {
                                        _dataByDate[index]['children'][idx]['day_'+parseInt(date.day)] 
                                        = this.fixDecimal(item.totalNormalTime)
                                    }
                                });
                                if (_dataByDate[index]['children'][idx]['children'][0] !== undefined) {
                                    _.map(emp.workLogDate, item => {
                                        if (parseInt(item.date.slice(-2)) === parseInt(date.day)) {
                                            _dataByDate[index]['children'][idx]['children'][0]['day_'+parseInt(date.day)] 
                                            = (item.totalOvertime !== 0) ? this.fixDecimal(item.totalOvertime) : ''
                                        }
                                    });
                                }
                            }
                        });          
                    }
                });
            }
        });

        this.setState({
            dataByDate: _dataByDate
        });

        let _dataByProject = [];
        if (dataByProject['departmentEmployee']) {
            _dataByProject = _.map(dataByProject['departmentEmployee'], (dep, index) => {
                return ({
                    "id": `${index}`,
                    "name": dep.departmentName,
                    "totalHour": this.fixDecimal(dep.totalHourDepartment),
                    "children": _.map(dep.workLog, (emp, idx) => {
                        return ({
                            "id": `${index}-${idx}`,
                            "name": emp.employeeName,
                            "totalHour": this.fixDecimal(emp.workLogProject[0].totalHourEmployee),
                            "employeeId": emp.employeeId
                        })
                    })
                })
            });
        }

        _projectSortTable.map((project, i) => {
            dataByProject['departmentEmployee'].map((dep, index) => {
                if (_dataByProject[index] !== undefined) {
                    dataByProject['totalHourProjectDepartment'].map(ite => {
                        if (parseInt(ite.departmentId) === parseInt(dep.departmentId) 
                            && parseInt(ite.projectId) === parseInt(project.id)) {
                            _dataByProject[index]['projectId_'+project.id] = this.fixDecimal(ite.totalProjectDepartment)
                        }
                    });
                            
                    dep.workLog.map((emp, idx) => {
                        if (_dataByProject[index]['children'][idx] !== undefined) {
                            emp.workLogProject.map(item => {
                                if (parseInt(item.projectId) === parseInt(project.id)) {
                                    _dataByProject[index]['children'][idx]['projectId_'+project.id] = this.fixDecimal(item.totalNormalTime)
                                }
                            });
                        }
                    })                
                }
            })
        });

        this.setState({
            dataByProject: _dataByProject
        });

        this.setState({
            dateInMonth: date,
            totalDateByDepartment: dataByDate['totalDateByDepartment'],
            projectSortCombobox: _projectSortCombobox,
            projectSortTable: _projectSortTable,
            OMProjectList: _OMProjectList,
            employeeList: _employeeList,
            supervisorList: _supervisorList,
            approverList: _approverList,
            departmentListSelectBox: _departmentListSlectBox,
            listEmloyeeSlectBox: _listEmloyeeSlectBox,
            departmentListSelectBoxExport: _departmentListSlectBoxExport,
            listEmloyeeSlectBoxExport: _listEmloyeeSlectBoxExport
            
        });
    }

    // Handle on change selectbox
    changeSelect = evt => {
        const name = evt.target.name;
        const value = evt.target.value;
        switch (name) {
            case 'year':
                this.setState({
                    currentYear: value
                });
                break;

            case 'month':
                this.setState(prevState => ({
                    currentMonth: value,
                    inputSubmit: {
                        ...prevState.inputSubmit,
                        formError: {
                            ...prevState.inputSubmit.formError,
                            currentMonth: ""
                        }
                    }
                }));
                break;
              
            default:   
                this.setState({
                    projectId: value
                });
                break;
        }

    }

    // Handle on change select project
    changeSelectProject = evt => {
        const value = evt._value;
        this.setState({
           projectId: value
        });
    }

    // Handle on change select department
    async changeSelectDepartment(evt) {
        const value = evt._value;
        if (value !== ' ') {
            await this.setState({
                departmentId: value
            })
            await this.setState(prevState => {
                const departmentParam = Object.assign({}, prevState.paramDepartmentListAndEmployee);
                departmentParam.departmentId = Number(value);
                return { departmentParam };
            })
            this.props.getDataDepartmentAndEmployee(this.state.departmentParam)
        }
        else {
            const valueAll = ''
            await this.setState({
                departmentId: valueAll
            })
            await this.setState(prevState => {
                const departmentParamAll = Object.assign({}, prevState.paramDepartmentListAndEmployee);
                departmentParamAll.departmentId = valueAll;
                return { departmentParamAll };
                })
            this.props.getDataDepartmentAndEmployee(this.state.departmentParamAll)
        }
    }


    // Handle on change select employee
    changeSelectEmployee = (evt)=> {
        const value = evt._value;
        if (value.length === 0) {
            const valueAll = ''
            this.setState({
                employeeId: valueAll
            })
        }
        else {
            this.setState({
                employeeId: value
            })
        }
    }

    // Handle on change select department modal
    async changeSelectDepartmentModal(evt) {
        const value = evt._value;
        if (value !== ' ') {
            await this.setState({
                departmentId: value
            })
            await this.setState(prevState => {
                const departmentParam = Object.assign({}, prevState.paramDepartmentListAndEmployeeExport);
                departmentParam.departmentId = Number(value);
                return { departmentParam };
            })
            this.props.getDataDepartmentAndEmployeeExport(this.state.departmentParam)
        }
        else {
            const valueAll = ''
            await this.setState({
                departmentId: valueAll
            })
            await this.setState(prevState => {
                const departmentParamAll = Object.assign({}, prevState.paramDepartmentListAndEmployeeExport);
                departmentParamAll.departmentId = valueAll;
                return { departmentParamAll };
                })
            this.props.getDataDepartmentAndEmployeeExport(this.state.departmentParamAll)
        }
    }

    //// Handle on change select employee
    changeSelectEmployeeModal = (evt)=> {
        const value = evt._value;
        if (value.length === 0) {
            const valueAll = [];
            this.setState({
                employeeIdExport: valueAll
            })
        }
        else {
            this.setState({
                employeeIdExport: value
            })
        }
    }

    // Handle on change totalRecordBy
    changeTotalRecordBy = evt => {
        const value = evt.target.value;   
        this.setState({
            totalRecordBy: value
        });
    }

    // Event when click btn Search
    async searchTotalRecordByDate() {
        if (!this.checkValidate()) return;
        const year = this.state.currentYear;
        const month = this.state.currentMonth;
        const departmentId = this.state.departmentId;
        const employeeId = this.state.employeeId.toString();
        let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + 
        '?month=' + month  + '&year=' + year + '&searchBy=date';
        window.history.pushState({path:newurl},'', newurl);
        await this.setState({
            searchBy: "date",
            paramListByDate: {
                isSearch: 1,
                month: month,
                year: year,
                departmentId: departmentId,
                'employeeId[]': employeeId,
                departmentBy: "createdDate-ASC",
                projectBy: "projectCode-ASC",
                employeeBy: "lastName-ASC"
            },
            dataByDate: [],
            dataByProject: [],
            searching: true
        });

        return this.props.getTotalRecordByDate2(this.state.paramListByDate);
    }

    // Event when click btn Search
    async searchTotalRecordByProject() {
        if (!this.checkValidate()) return;
        const year = this.state.currentYear;
        const month = this.state.currentMonth;
        const departmentId = this.state.departmentId;
        const employeeId = this.state.employeeId.toString();
        const projectId = this.state.projectId;
        let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + 
        '?month=' + month  + '&year=' + year + '&searchBy=project&projectId=' + projectId ;
        window.history.pushState({path:newurl},'', newurl);
        await this.setState({
            searchBy: "project",
            paramListByProject: {
                isSearch: 1,
                projectId: projectId,
                month: month,
                year: year,
                departmentId: departmentId,
                'employeeId[]': employeeId,
                departmentBy: "createdDate-ASC",
                projectBy: "projectCode-ASC",
                employeeBy: "lastName-ASC",
                employeeProjectBy: "createdDate-ASC"
            },
            dataByDate: [],
            dataByProject: [],
            searching: true
        });

        return this.props.getTotalRecordByProject(this.state.paramListByProject);
    }

    // Double click on employee row
    totalRecordDetail = (e, i) => {
        let month = (this.state.searchBy === 'date') ? this.state.paramListByDate.month : this.state.paramListByProject.month;
        let year = (this.state.searchBy === 'date') ? this.state.paramListByDate.year : this.state.paramListByProject.year;
        let searchBy = this.state.searchBy;
        let projectId = (this.state.searchBy === 'project') ? this.state.projectId : '';
        if (e !== undefined) {
            window.location = '/total-record-detail?employeeId='+ e + '&month=' + month + '&year=' + year + '&searchBy=' + searchBy + '&projectId=' + projectId;
        }
    }

    gotoShiftControl = () => {
        let month = (this.state.searchBy === 'date') ? this.state.paramListByDate.month : this.state.paramListByProject.month;
        let year = (this.state.searchBy === 'date') ? this.state.paramListByDate.year : this.state.paramListByProject.year;
        let searchBy = this.state.searchBy;
        let projectId = (this.state.searchBy === 'project') ? this.state.projectId : '';
        setTimeout( function() {
            window.location = '/shift-control?month=' + month + '&year=' + year + '&searchBy=' + searchBy + '&projectId=' + projectId;
        }, 500);
    } 

    fixDecimal = (val) => {
        return (functionCommon.isDecimal(val)) 
        ? Number(parseFloat(val).toFixed(2)) 
        : val
    }

    tableByDate = () => {
        const { t } = this.props;
        const { columnsByDate, dataByDate } = this.state;

        let defaultExpandedRowKeys = [];
        _.map(dataByDate, (item, index) => {
            defaultExpandedRowKeys.push(`${index}`)
            _.map(item['children'], (ite, idx) => {
                defaultExpandedRowKeys.push(`${index}-${idx}`)
            })
        });

        return (
            (!this.state.searching) 
            ? <Table className="table-by-date" 
                fixed
                width={1270}
                maxHeight={500}
                columns={columnsByDate} 
                data={dataByDate}
                expandColumnKey="name"
                defaultExpandedRowKeys={defaultExpandedRowKeys}
                headerHeight={32}
                rowHeight={32}
                cellProps={(record, index) => {
                    return {
                        onDoubleClick: event => {
                            if (record.columnIndex === 0) {
                                this.totalRecordDetail(record.rowData.employeeId, index)
                            }
                        }                        
                    };
                }}
            />
            : <div></div>
        )
    }

    tableByProject = () => {
        const { columnsByProject, dataByProject, projectsLength } = this.state;

        let defaultExpandedRowKeys = [];
        _.map(dataByProject, (item, index) => {
            defaultExpandedRowKeys.push(`${index}`);
        });
        console.log(this.state.projectId)
        return (
            (!this.state.searching) 

            ? <Table className={this.state.projectId !== '' ? 'table-by-project search-project-table' : 'table-by-project'} 
                fixed
                width={1170}
                maxHeight={500}
                columns={columnsByProject} 
                data={dataByProject}
                expandColumnKey="name"
                defaultExpandedRowKeys={defaultExpandedRowKeys}
                headerHeight={32}
                rowHeight={32}
                cellProps={(record, index) => {
                    return {
                        onDoubleClick: event => {
                            if (record.columnIndex === 0) {
                                this.totalRecordDetail(record.rowData.employeeId, index)
                            }
                        }                        
                    };
                }}
            />
            : <div></div>
        )
    }

    // Event when click btn Export
    ExportAction = () => {
        let exportParam = {};
        let urlDownfile = 'EngineerHourRecord/reportConditionByYearProject';

        if (this.state.totalRecordBy === "project") {
            if (this.state.projectId === '') {
                exportParam = {
                    month: this.state.currentMonth,
                    year: this.state.currentYear
                };
                urlDownfile = 'EngineerHourRecord/exportYearMonth';
            } else {
                exportParam = {
                    month: this.state.currentMonth,
                    year: this.state.currentYear,
                    projectID: this.state.projectId
                };
                if (this.state.currentMonth !== '') {
                    urlDownfile = 'EngineerHourRecord/reportConditionByYearMonthProject';
                }                
            }
        }

        this.props.exportFileAction({
            'urlGetkey': 'OMProject/requestSecretKey',
            'urlDownfile': urlDownfile
        }, exportParam)
    }

    // Event when click btn ER Report
    ERExportAction = () => {
        if (!this.checkValidate()) return;
        let exportParam = {}
        exportParam = {
            month: this.state.currentMonth,
            year: this.state.currentYear
        };
        
        this.props.exportFileAction({
            'urlGetkey': 'OMProject/requestSecretKey',
            'urlDownfile':  'EngineerHourRecord/erReport'
        }, exportParam)
    }

    // Event when click btn Export All Employee
    ExportAllEmployeeAction = () => {
        if (!this.checkValidate()) return;
        if (this.state.employeeIdExport.length !== 0) {
            const employeeId = this.state.employeeIdExport.toString()
            let exportParam = {
                departmentId: this.state.departmentId,
                'employeeId[]': employeeId,
                month: this.state.currentMonth,
                year: this.state.currentYear
            };
            this.props.exportAllEmployee({
                'urlGetkey': 'WorkLog/getSecretKey',
                'urlDownfile': 'WorkLog/exportAllEmployee'
            }, exportParam)
        }
        else {
            const employeeId = []
            let exportParam = {
                departmentId: this.state.departmentId,
                employeeId: employeeId,
                month: this.state.currentMonth,
                year: this.state.currentYear
            };
            this.props.exportAllEmployee({
                'urlGetkey': 'WorkLog/getSecretKey',
                'urlDownfile': 'WorkLog/exportAllEmployee'
            }, exportParam)
        }
        
    }

    // Event when click btn Monthly Summary
    ExportMonthlySummary = () => {
        if (!this.checkValidate()) return;
        let exportParam = {
            month: this.state.currentMonth,
            year: this.state.currentYear
        };

        this.props.exportFileAction({
            'urlGetkey': 'OMProject/requestSecretKey',
            'urlDownfile': 'EngineerHourRecord/monthlySummaryExport'
        }, exportParam)
    }

    // Event when click btn Export Er Status
    exportErStatus = (param) => {
        let exportParam = {}
        const employeeId = param.employeeId.toString();
        if (param.employeeId.length !== 0) {
            exportParam = {
                departmentId: param.departmentId,
                'employeeId[]': employeeId,
                dayFrom: moment(param.dateFrom, "DD/MM/YYYY").format("YYYY-MM-DD"),
                dayTo: moment(param.dateTo, "DD/MM/YYYY").format("YYYY-MM-DD"),
            };
            this.props.exportErStatus({
                'urlGetkey': 'WorkLog/getSecretKey',
                'urlDownfile': 'WorkLog/exportERStatus'
            }, exportParam)
        } else {
            const employeeId = []
            exportParam = {
                departmentId: param.departmentId,
                employeeId: "",
                dayFrom: moment(param.dateFrom, "DD/MM/YYYY").format("YYYY-MM-DD"),
                dayTo: moment(param.dateTo, "DD/MM/YYYY").format("YYYY-MM-DD"),
            };
            this.props.exportErStatus({
                'urlGetkey': 'WorkLog/getSecretKey',
                'urlDownfile': 'WorkLog/exportERStatus'
            }, exportParam)
        }
    }

    // Check validate form
    checkValidate = () => {
        let isValidate = false;
        let _formError = {};
        (this.state.currentMonth === "") ? _formError["currentMonth"] = "message.500" : _formError["currentMonth"] = "";

        if (this.state.currentMonth !== "") {
            isValidate = true;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: {}
                }
            }));
        } else {
            isValidate = false;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: _formError
                }
            }));
        }
        return isValidate;
    }

    show = (size, modalStyle) => () => {
        this.setState({ size, open: true, modalStyle: modalStyle });
        if (modalStyle === "statusERModal") {
            this.props.deleteDataEmployeeExport();
            this.props.getDataDepartmentAndEmployeeExport(this.state.paramDepartmentListAndEmployeeExport);
        } else if (modalStyle === "exportER") {
            this.props.deleteDataEmployeeExport();
            this.props.getDataDepartmentAndEmployeeExport(this.state.paramDepartmentListAndEmployeeExport);
        }
     }
    close = () => this.setState({ open: false, modalStyle: '', departmentId: '', employeeIdExport: [] })

    render() {
        const { t } = this.props;
        const { currentMonth, currentYear, projectSortCombobox,
            totalRecordBy, errorCode, searchBy, projectId,
            size, open, OMProjectList, employeeList, supervisorList, approverList, listEmloyeeSlectBox, listEmloyeeSlectBoxExport } = this.state;
        return (
            <div className="inquiry-data-form">
                <h2 className="page-heading">
                    <span onClick={() => setTimeout(function() { window.location = '/' }, 500)}>
                        {t("navigation.engineerHourRecord")}
                    </span>
                    /{" "}
                    <span onClick={() => setTimeout(function() { window.location = '/total-record' }, 500)}>
                        {t("navigation.totalRecord")}
                    </span>
                </h2>
                <div className="list-actions total-record-actions">
                    {(!isStaffSupervisor)
                    ? <Button primary disabled={this.state.searching} onClick={() => 
                        (totalRecordBy === "date") ? this.searchTotalRecordByDate() : this.searchTotalRecordByProject()}>
                        <Icon name="search"/>{this.state.searching ?  t("button.searching") : t("button.search")}
                    </Button>
                    : ''}
                    <Button onClick={this.show('tiny', 'erForm')}>
                        <Icon name="file excel outline"/>{t("button.importER")}
                    </Button>
                    <Button onClick={this.show('tiny', 'erOmForm')}>
                        <Icon name="file excel outline"/>{t("button.importEROM")}
                    </Button>
                    {(!isStaffSupervisor)
                    ? <Button primary onClick={e => this.gotoShiftControl()}>
                        <Icon name="cog"/>{t("button.shiftControl")}
                    </Button> : ''}
                    {(!isStaffSupervisor)
                    ? <Button onClick={e => this.ERExportAction()}>
                        <Icon name="file excel outline"/>{t("button.erReport")}
                    </Button> : ''}
                    {(!isStaffSupervisor)
                    ? <Button onClick={e => this.ExportAction()}>
                        <Icon name="file excel outline"/>{t("button.export")}
                    </Button> : ''}
                    {(!isStaffSupervisor)
                    ? <Button onClick={this.show('tiny', 'otLeaveForm')}>
                        <Icon name="file excel outline"/>{t("button.exportOTLeave")}
                    </Button> : ''}
                    {(!isStaffSupervisor)
                    ? <Button onClick={this.show('tiny', 'exportER')}>
                        <Icon name="file excel outline"/>{t("button.exportAllEmployee")}
                    </Button> : ''}
                    {(!isStaffSupervisor)
                    ? <Button onClick={e => this.ExportMonthlySummary()}>
                        <Icon name="file excel outline"/>{t("button.monthlySummary")}
                    </Button> : ''}
                    {!isStaffSupervisor
                    && <Button onClick={this.show('tiny', 'statusERModal')}>
                        <Icon name="file excel outline"/>{t("button.exportERStatus")}
                    </Button>}
                </div>  
                {(!isStaffSupervisor)
                    ? <TotalRecordForm
                        projectId={projectId}
                        changeSelect={input => this.changeSelect(input)}
                        changeSelectProject={input => this.changeSelectProject(input)}
                        changeTotalRecordBy={input => this.changeTotalRecordBy(input)}
                        totalRecordBy={totalRecordBy}
                        projectDataValue={projectSortCombobox}
                        isError={this.state.inputSubmit.formError}
                        currentValueMonth={currentMonth}
                        currentValueYear={currentYear}
                        changeSelectDepartment={input => this.changeSelectDepartment(input)}
                        changeSelectEmployee={input => this.changeSelectEmployee(input)}
                        dataDepartmentSlectBox={this.state.departmentListSelectBox}
                        dataEmployeeSlectBox={listEmloyeeSlectBox}
                    />
                    : ''}
                {errorCode ? (
                    <div className="error-message list-error-message">
                        {t("message." + errorCode)}
                    </div>
                ) : (
                        ""
                    )}
                {(!isStaffSupervisor)
                ? <div className="table-responsive total-record-wrap">
                    <div className="total-record-table">
                        {(searchBy === "date") ? this.tableByDate() : this.tableByProject()}
                    </div>
                </div>
                : ''}
                {
                    this.state.modalStyle !== '' ?   
                    <ERModal 
                        size={size} 
                        open={open} 
                        handleClose={this.close}
                        modalStyle={this.state.modalStyle}
                        projectData={OMProjectList}
                        employeeData={employeeList}
                        supervisorData={supervisorList}
                        approverData={approverList}
                        currentValueMonth={currentMonth}
                        currentValueYear={currentYear}
                        isStaffSupervisor={isStaffSupervisor}
                        dataDepartmentSlectBox={this.state.departmentListSelectBox}
                        dataEmployeeSlectBox={listEmloyeeSlectBoxExport}
                        changeSelectDepartmentModal={input => this.changeSelectDepartmentModal(input)}
                        changeSelectEmployeeModal={input => this.changeSelectEmployeeModal(input)}
                        buttonExport={button => this.ExportAllEmployeeAction(button)}
                        buttonExportErStatus={button => this.exportErStatus(button)}
                    /> : ''
                }
            </div>
        )
    }
}
const mapStateToProps = state => ({
    ...state
});

const mapDispatchToProps = dispatch => ({
    getTotalRecordByDate: opt => dispatch(getTotalRecordByDate(opt)),
    getTotalRecordByDate2: opt => dispatch(getTotalRecordByDate2(opt)),
    getTotalRecordByProject: opt => dispatch(getTotalRecordByProject(opt)),
    getProjectEmployeeSort: opt => dispatch(getProjectEmployeeSort(opt)),
    exportFileAction: (url, param) => dispatch(exportFileAction(url, param)),
    getDataDepartmentAndEmployee: (opt) => dispatch(getDataDepartmentAndEmployee(opt)),
    getDataDepartmentAndEmployeeExport: (opt) => dispatch(getDataDepartmentAndEmployeeExport(opt)),
    exportAllEmployee: (url, param) => dispatch(exportAllEmployee(url, param)),
    exportErStatus: (url, param) => dispatch(exportErStatus(url,param)),
    deleteDataEmployeeExport: () => dispatch(deleteDataEmployeeExport())
});

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(TotalRecord);
